import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'
import { Permission } from './permissions'

export const catalogAdminQualityAuditAccessConfiguration: DomainAccessControlConfig = [
  {
    permissions: Permission.QualityAuditViewAccess,
  },
  {
    permissions: Permission.QualityAuditSamaViewAccess,
  },
  {
    permissions: Permission.QualityAuditEyViewAccess,
  },
  {
    permissions: Permission.QualityAuditKpmgViewAccess,
  },
]

export const showQasWorkflowActions: DomainAccessControlConfig = {
  featureToggles: [FeatureToggle.ShowQasWorkflowActions],
}

export const canOutsourceModifyAssigneeAccess: DomainAccessControlConfig = [
  {
    permissions: Permission.QualityAuditSamaModifyAssigneeAccess,
  },
  {
    permissions: Permission.QualityAuditEyModifyAssigneeAccess,
  },
  {
    permissions: Permission.QualityAuditKpmgModifyAssigneeAccess,
  },
]

export const canOutsourceModifyReviewerAccess: DomainAccessControlConfig = [
  {
    permissions: Permission.QualityAuditSamaModifyReviewerAccess,
  },
  {
    permissions: Permission.QualityAuditEyModifyReviewerAccess,
  },
  {
    permissions: Permission.QualityAuditKpmgModifyReviewerAccess,
  },
]
